import React, { Component } from 'react';
import ReactSelect from '../../components/ReactSelect';
import { purchaseQuery } from './query';
import Loading from '../../components/Loading';
import Message from '../Message';
import BuyMoreEntitiesModal from './modal';
import { withTranslation } from 'react-i18next';

class PurchaseMoreEntity extends Component {
    constructor(props) {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.onBuy = this.onBuy.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.calculateTotalPrice = this.calculateTotalPrice.bind(this);
        this.onChageCustomValue = this.onChageCustomValue.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showName = this.showName.bind(this);
        this.getQuantity = this.getQuantity.bind(this);
        this.getObjectName = this.getObjectName.bind(this);
        this.getMessage = this.getMessage.bind(this);

        this.isAiTrackingCredit = props.item?.object_name === 'prompt_tracking_credits';

        this.state = {
            selectedOption: this.isAiTrackingCredit ? 20 : 1,
            openCustomInput: false,
            customValue: 0,
            isLoading: false,
            plan: '',
            message: '',
            current_plan_interval: '',
            message_tags: '',
            isContentLoading: true,
            isOpenModal: false,
        };
    }

    openModal() {
        this.setState({
            isOpenModal: true,
        });
    }

    closeModal() {
        this.setState({
            isOpenModal: false,
        });
    }

    showName(key) {
        const { t } = this.props;

        const names = {
            content_analysis: t('purchase_add_ons.content_analysis'),
            commerce_analytics: t('purchase_add_ons.commerce_analytics'),
            entities: t('purchase_add_ons.entities'),
            seats: t('purchase_add_ons.seats'),
        };

        return names[key];
    }

    async onBuy() {
        const { t } = this.props;
        const quantity = Number(this.state.customValue) || this.state.selectedOption;
        const min = this.props.item.min;
        this.closeModal();
        if (quantity < min) {
            this.setState({
                message_tags: 'error',
                message: `Quantity must be greater than ${min}`,
                isLoading: false,
            });
            return;
        }
        try {
            this.setState({
                isLoading: true,
            });
            const params = {
                quantity,
                object_name: this.props.item.object_name,
            };

            const response = await purchaseQuery(params, this.props.csrf_token);
            this.closeModal();
            const data = await response.json();
            if (data.status === 400) {
                this.setState({
                    message_tags: 'error',
                    message: data.message,
                    isLoading: false,
                });
            } else {
                this.setState({
                    message_tags: 'success',
                    message: t('purchase_add_ons.success_message'),
                    isLoading: false,
                    selectedOption: 1,
                    customValue: 0,
                    openCustomInput: false,
                });
            }
        } catch (err) {
            this.setState({
                message_tags: 'error',
                message: t('purchase_add_ons.error_message'),
                isLoading: false,
            });
            console.log(err);
        }
    }

    handleChange(value) {
        if (value === 'custom') {
            this.setState({
                selectedOption: '',
                openCustomInput: true,
            });
        } else {
            this.setState({
                selectedOption: value,
                openCustomInput: false,
                customValue: 0,
            });
        }
    }

    onChageCustomValue(e) {
        this.setState({
            customValue: e.target.value,
        });
    }

    deleteMessage() {
        this.setState({ message: '' });
    }

    calculateTotalPrice(selectedAmount) {
        if (this.props.item.additional_price?.length === 1) {
            const price = this.props.item.additional_price[0]?.unit_amount;
            return price ? price / 100 : 0;
        }
        const price = this.props.item.additional_price.find((item, i, arr) => {
            if (i === 0 && selectedAmount > item?.up_to) return false;
            if (i === 0 && selectedAmount <= item?.up_to) return true;
            if (i === arr.length - 1) return true;
            if (selectedAmount > arr[i - 1]?.up_to && selectedAmount <= item.up_to) return true;

            return false;
        })?.unit_amount;

        return price ? price / 100 : 0;
    }

    hasMoreThanThreeDecimals(num) {
        var decimalPart = (num % 1).toString();
        return decimalPart.length > 4;
    }

    toFix(num) {
        return this.hasMoreThanThreeDecimals(num) ? num.toFixed(2) : num;
    }

    getQuantity(item, i, arr) {
        const { t } = this.props;
        const firstNumber = i === 0 ? 1 : arr[i - 1]?.up_to + 1;

        if (this.isAiTrackingCredit) {
            return <div>{t('purchase_add_ons.ai_tracking_intro')}</div>;
        }

        const secondNumber = item?.up_to ?? '...';
        let intro = '';
        if (i === 0) {
            intro = t('purchase_add_ons.for_the_first');
        } else if (i === arr.length - 1) {
            intro = t('purchase_add_ons.for_the_rest');
            return intro;
        } else {
            intro = t('purchase_add_ons.for_the_next');
        }
        return (
            <div>
                {intro}{' '}
                <strong>
                    {firstNumber} {t('purchase_add_ons.to')} {secondNumber}
                </strong>
            </div>
        );
    }

    getObjectName() {
        const { t } = this.props;

        switch (this.props.item.object_name) {
            case 'content_analysis':
                return t('purchase_add_ons.analysis');
            case 'seats':
                return t('purchase_add_ons.seats');
            default:
                return t('purchase_add_ons.entity');
        }
    }

    getMessage(object_name) {
        const { t } = this.props;
        const versions = {
            content_analysis: t('purchase_add_ons.versions.content_analysis'),
            entities: t('purchase_add_ons.versions.entities'),
            seats: t('purchase_add_ons.versions.seats'),
        };

        return versions[object_name];
    }

    render() {
        const { t } = this.props;
        const options = [
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '5', value: 5 },
            { label: '10', value: 10 },
            { label: '20', value: 20 },
            { label: '50', value: 50 },
            {
                label: (
                    <div className="align-items-center">
                        <button className="dropdown-custom-btn">
                            {t('purchase_add_ons.custom_value')}
                        </button>
                    </div>
                ),
                value: 'custom',
            },
        ];

        const optionsFiltered = options.filter(
            (item) => item.value === 'custom' || item.value >= (this.props.item.min || 1),
        );
        const selectedAmount = Number(this.state.customValue || this.state.selectedOption);
        const price = this.calculateTotalPrice(selectedAmount);
        return (
            <>
                <div>
                    <>
                        <div className="purchase-new-entity-container">
                            <div>
                                {this.props.item.additional_price?.length !== 0 && (
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{t('purchase_add_ons.quantity')}</th>
                                                <th>
                                                    {t('purchase_add_ons.price_per')}{' '}
                                                    {this.getObjectName()}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.item.additional_price?.map(
                                                (item, i, arr) => {
                                                    const quantity = this.getQuantity(item, i, arr);
                                                    return (
                                                        <tr key={item.up_to}>
                                                            <td>{quantity}</td>
                                                            <td>$ {item?.unit_amount / 100}</td>
                                                        </tr>
                                                    );
                                                },
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            <div>
                                <div className="purchase-new-entity-container-info">
                                    <div className="d-flex justify-content-between w-100 align-items-center">
                                        {t('purchase_add_ons.quantity')}
                                        <div className="d-flex gap-6">
                                            <ReactSelect
                                                options={optionsFiltered}
                                                value={optionsFiltered.find(
                                                    (x) => x.value === this.state.selectedOption,
                                                )}
                                                isSearchable={false}
                                                onChange={this.handleChange}
                                                blurInputOnSelect={true}
                                                classname="m-0 bold-label"
                                                controlStyles={{
                                                    minWidth: '165px',
                                                }}
                                            />
                                            {this.state.openCustomInput && (
                                                <input
                                                    type="number"
                                                    className="custom-value"
                                                    value={this.state.customValue}
                                                    onChange={this.onChageCustomValue}
                                                    min={this.props.item.min || 0}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between w-100 align-items-center">
                                        {t('purchase_add_ons.total_price')}
                                        <div className="purchase-new-entity-container-info-total">
                                            $ {this.toFix(selectedAmount * price)} /{' '}
                                            {this.props.item.current_plan_interval}
                                        </div>
                                    </div>
                                </div>
                                <div className="purchase-new-entity-container-help">
                                    {t('purchase_add_ons.quantity', {
                                        object_name: this.showName(this.props.item.object_name),
                                        name:
                                            this.props.item.object_name === 'entities'
                                                ? ' tracking '
                                                : ' ',
                                        current_plan_interval:
                                            this.props.item?.current_plan_interval,
                                    })}
                                </div>
                                <button
                                    className="button button-filled button-primary btn d-flex align-items-center justify-content-center mt-10 px-35"
                                    onClick={this.openModal}
                                    disabled={
                                        !this.props.item.additional_price ||
                                        !price ||
                                        this.state.isLoading
                                    }
                                >
                                    {t('purchase_add_ons.buy_now')}
                                </button>
                                {this.state.isLoading && <Loading padding={10} />}
                            </div>
                        </div>
                    </>
                </div>

                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
                <BuyMoreEntitiesModal
                    object_message={this.getMessage(this.props.item.object_name)}
                    isOpen={this.state.isOpenModal}
                    onClose={this.closeModal}
                    entityCount={selectedAmount}
                    onSubmit={this.onBuy}
                    totalPrice={this.toFix(selectedAmount * price)}
                    period={this.props.item.current_plan_interval}
                />
            </>
        );
    }
}

export default withTranslation()(PurchaseMoreEntity);
